import React, { useEffect, createElement } from 'react';
import { Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { UpsellPage } from './pages/UpsellPage';
import { Inmunidad27Page } from './pages/Inmunidad27Page';
import { Upsell1InmunidadPage } from './pages/Upsell1InmunidadPage';
import { ThankYou1Page } from './pages/ThankYou1Page';
import { InmunidadTot27Page } from './pages/InmunidadTot27Page';
import { Oportunidad1Page } from './pages/Oportunidad1Page';
import { GuiaSosPage } from './pages/GuiaSosPage';
import { NegacionPage } from './pages/NegacionPage';
import { MetodoBatchPage } from './pages/MetodoBatchPage';
import { MuchasGraciasPage } from './pages/MuchasGraciasPage';
import { SalesPageV2 } from './pages/SalesPageV2';
import { SalesPageV3 } from './pages/SalesPageV3';
import { SalesPageV4 } from './pages/SalesPageV4';
import { SalesPageV5 } from './pages/SalesPageV5';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  useEffect(() => {
    // UTMify UTMs script
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    document.head.appendChild(utmifyScript);
    (window as any).pixelId = '69a84f432f2498111cab00d3';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // Google tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H6W0NPCL3K';
    document.head.appendChild(gtagScript);
    const gtagInline = document.createElement('script');
    gtagInline.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-H6W0NPCL3K');
    `;
    document.head.appendChild(gtagInline);
    // Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-558L5RR8');`;
    document.head.appendChild(gtmScript);
  }, []);
  return <Routes data-id="element-0">
      <Route path="/" element={<>
            <SalesPage data-id="element-2" />
            <RecentPurchaseToast data-id="element-3" />
          </>} data-id="element-1" />
      <Route path="/inmunidadtot" element={<UpsellPage data-id="element-5" />} data-id="element-4" />
      <Route path="/immunitytot" element={<UpsellPage data-id="element-7" />} data-id="element-6" />
      <Route path="/inmunidad27" element={<Inmunidad27Page data-id="element-9" />} data-id="element-8" />
      <Route path="/immunity27" element={<Inmunidad27Page data-id="element-11" />} data-id="element-10" />
      <Route path="/up1inmunidad" element={<Upsell1InmunidadPage data-id="element-13" />} data-id="element-12" />
      <Route path="/up1immunity" element={<Upsell1InmunidadPage data-id="element-15" />} data-id="element-14" />
      <Route path="/inmunidadtot27" element={<InmunidadTot27Page data-id="element-17" />} data-id="element-16" />
      <Route path="/oportunidad1" element={<Oportunidad1Page data-id="element-19" />} data-id="element-18" />
      <Route path="/thankyou1" element={<ThankYou1Page data-id="element-21" />} data-id="element-20" />
      <Route path="/guiasos" element={<GuiaSosPage data-id="element-23" />} data-id="element-22" />
      <Route path="/negacion" element={<NegacionPage data-id="element-25" />} data-id="element-24" />
      <Route path="/metodobatch" element={<MetodoBatchPage data-id="element-27" />} data-id="element-26" />
      <Route path="/muchasgracias" element={<MuchasGraciasPage data-id="element-29" />} data-id="element-28" />
      <Route path="/v2" element={<>
            <SalesPageV2 data-id="element-31" />
            <RecentPurchaseToast data-id="element-32" />
          </>} data-id="element-30" />
      <Route path="/v3" element={<>
            <SalesPageV3 data-id="element-34" />
            <RecentPurchaseToast data-id="element-35" />
          </>} data-id="element-33" />
      <Route path="/v4" element={<>
            <SalesPageV4 data-id="element-37" />
            <RecentPurchaseToast priceOverrides={[{
        product: 'NutriPeques',
        price: '$18.90 USD',
        weight: 0.2
      }, {
        product: 'NutriPeques + 1',
        price: '$24.89 USD',
        weight: 0.4
      }, {
        product: 'NutriPeques + 2',
        price: '$30.88 USD',
        weight: 0.4
      }]} data-id="element-38" />
          </>} data-id="element-36" />
      <Route path="/v5" element={<>
            <SalesPageV5 data-id="element-40" />
            <RecentPurchaseToast priceOverrides={[{
        product: 'NutriPeques',
        price: '$14.99 USD',
        weight: 0.2
      }, {
        product: 'NutriPeques + 1',
        price: '$20.98 USD',
        weight: 0.4
      }, {
        product: 'NutriPeques + 2',
        price: '$26.97 USD',
        weight: 0.4
      }]} data-id="element-41" />
          </>} data-id="element-39" />
    </Routes>;
}